// extracted by mini-css-extract-plugin
export default {"container":"MagicPage_container__gKzw9","section":"MagicPage_section__UOjXk"};